'use client'

import { Link, Stack, Typography } from '@mui/material'
import React from 'react'

interface FooterLink {
	text: string
	href: string
}

interface FooterLinkSectionProps {
	title: string
	links: FooterLink[]
}

export const FooterLinkSection: React.FC<FooterLinkSectionProps> = ({ title, links }) => {
	return (
		<Stack spacing={2}>
			<Typography color='white' variant='body2' className='text-md font-bold'>
				{title}
			</Typography>
			<Stack spacing={2} direction='column'>
				{links.map((link, index) => (
					<Link
						key={index}
						href={link.href}
						underline='hover'
						className='text-white text-xs'
						sx={{
							color: 'white',
							whiteSpace: 'nowrap'
						}}>
						{link.text}
					</Link>
				))}
			</Stack>
		</Stack>
	)
}
